<div class="override-component">
  <div class="overide-tabs-wrapper">
    <div class="overides-tabs">
      <ul class="nav nav-pills" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            [class.active]="selectedTab === 'current'"
            class="nav-link"
            [class.active]="selectedTab === 'current'"
            id="pills-all-tab"
            data-bs-toggle="pill"
            data-bs-target="#pills-summary"
            type="button"
            role="tab"
            aria-controls="pills-all"
            aria-selected="true"
            (click)="changeTab('current')"
          >
            Current And Upcoming
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            [class.active]="selectedTab === 'all'"
            id="pills-all-tab"
            data-bs-toggle="pill"
            data-bs-target="#pills-summary"
            type="button"
            role="tab"
            aria-controls="pills-all"
            aria-selected="false"
            (click)="changeTab('all')"
          >
            All
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            class="nav-link"
            [class.active]="selectedTab === 'expired'"
            id="pills-all-tab"
            data-bs-toggle="pill"
            data-bs-target="#pills-summary"
            type="button"
            role="tab"
            aria-controls="pills-all"
            aria-selected="false"
            (click)="changeTab('expired')"
          >
            Past
          </button>
        </li>
      </ul>
    </div>
  </div>
  <div class="company-container">
    <div class="top-part">
      <div class="top-part-wrap">
        <div class="first-section d-flex align-items-center">
          <h5 class="mb-0 table-title">Overrides</h5>
        </div>

        <div
          class="second-section d-flex align-items-center justify-content-end g-3"
          style="display: flex; gap: 25px; padding-bottom: 1em"
        >
          <!-- Search Bar -->
          <div class="sales-report-filters d-flex">
            <div class="filter-wrapper">
              <div class="searchbar d-flex ms-2">
                <img
                  class="search me-2"
                  src="../../../assets/icons/searchbar.svg"
                  alt="Search"
                />
                <input
                  type="text"
                  placeholder="Search by description"
                  (input)="onSearchInput($event)"
                />
              </div>
            </div>
          </div>

          <!-- Create Button -->
          <div>
            <button
              class="btn add-btn"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRight"
              aria-controls="offcanvasRight"
              (click)="resetForm()"
            >
              + Create Override
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Data Table -->
    <section class="intro">
      <div class="table-container">
        <table class="table category-table table-condensed">
          <thead class="main-head sticky-top">
            <tr>
              <th scope="col">Description</th>
              <th scope="col">Store</th>
              <th scope="col">Date</th>
              <th *ngIf="showWeekColor" scope="col">Week Color</th>
              <th scope="col">Reminder Date</th>
              <th scope="col">License Plate</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let override of overridesList$ | async;
                trackBy: trackByOverrideId
              "
            >
              <td>{{ override.description }}</td>
              <td>{{ getStoreName(override.destinationStoreId) }}</td>
              <td>{{ override.weekColorDate | date: "MM-dd-yyyy" }}</td>
              <td *ngIf="showWeekColor">
                <span
                  [style.backgroundColor]="override.weekColor"
                  class="bgColor"
                >
                  {{ override.weekColor }}</span
                >
              </td>
              <td>{{ override.reminderDate | date: "MM-dd-yyyy" }}</td>
              <td>
                <div class="ms-3 licensePlateGroup view-more">
                  <small
                    *ngIf="(override.licensePlates.length || 0) > 0"
                    style="cursor: pointer"
                    (click)="
                      openLicensePlateLink(
                        override.licensePlates[0].licensePlate.id
                      )
                    "
                  >
                    {{ override.licensePlates[0].licensePlate.referenceNumber }}
                  </small>
                  <div
                    *ngIf="(override.licensePlates.length || 0) > 1"
                    class="show-list"
                  >
                    <ul>
                      <li
                        *ngFor="let lp of override.licensePlates"
                        style="cursor: pointer"
                        (click)="openLicensePlateLink(lp.licensePlate.id)"
                      >
                        {{ lp.licensePlate.referenceNumber }}
                      </li>
                    </ul>
                  </div>
                </div>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <span matTooltip="Edit Record" matTooltipPosition="above">
                    <img
                      src="../../../assets/Pricingscreen/update.svg"
                      class="svg-icon me-3"
                      style="cursor: pointer"
                      alt="Edit"
                      (click)="editOverride(override)"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasRight"
                      aria-controls="offcanvasRight"
                    />
                  </span>
                  <span
                    matTooltip="Disable Override"
                    matTooltipPosition="above"
                  >
                    <img
                      src="../../../assets/Pricingscreen/setting.svg"
                      class="svg-icon"
                      [class.disabled-icon]="!override.isDeletable"
                      alt="Settings"
                      (click)="
                        override.isDeletable && openDisablePopup(override)
                      "
                    />
                  </span>
                  <span matTooltip="Copy Override" matTooltipPosition="above">
                    <img
                      *ngIf="copyingId !== override.id"
                      src="../../../assets/admin-home/copy-icon.svg"
                      class="svg-icon ms-3"
                      style="cursor: pointer"
                      alt="Copy"
                      (click)="copyOverride(override.id)"
                    />
                    <div
                      *ngIf="copyingId === override.id"
                      class="copy-spinner-container"
                    >
                      <i class="fa fa-spinner fa-spin"></i>
                    </div>
                  </span>
                  <span
                    matTooltip="Print License Plates"
                    matTooltipPosition="above"
                    class="relative"
                  >
                    <ng-container
                      *ngIf="
                        !isPrinting || printingOverrideId !== override.id;
                        else printingIcon
                      "
                    >
                      <img
                        src="../../../assets/onboarding/ic_printer.svg"
                        class="svg-icon ms-3"
                        [style.opacity]="
                          override.licensePlates &&
                          override.licensePlates.length > 0
                            ? '1'
                            : '0.5'
                        "
                        [style.cursor]="
                          override.licensePlates &&
                          override.licensePlates.length > 0
                            ? 'pointer'
                            : 'not-allowed'
                        "
                        alt="Print"
                        (click)="onPrintClick(override, $event)"
                        [attr.data-bs-toggle]="
                          labelFormats.length === 1 ? null : 'modal'
                        "
                        [attr.data-bs-target]="
                          labelFormats.length === 1 ? null : '#labelFormatModal'
                        "
                      />
                    </ng-container>
                    <ng-template #printingIcon>
                      <i
                        class="fa fa-spinner fa-spin ms-3 print-spinner-icon"
                      ></i>
                    </ng-template>
                  </span>
                </div>
              </td>
            </tr>

            <!-- Loading State -->
            <tr *ngIf="isLoadingOverrides">
              <td [attr.colspan]="showWeekColor ? 7 : 6" class="text-center py-4">
                <i class="fa fa-spinner fa-spin me-2"></i>
                <span class="text-muted">Loading overrides...</span>
              </td>
            </tr>

            <!-- Empty State -->
            <tr
              *ngIf="!isLoadingOverrides && (overridesList$ | async)?.length === 0"
            >
              <td [attr.colspan]="showWeekColor ? 7 : 6" class="text-center py-4">
                <p class="mb-0 text-muted">No overrides found</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>

  <!-- Off-canvas Modal -->
  <div
    class="offcanvas offcanvas-end"
    tabindex="-1"
    id="offcanvasRight"
    aria-labelledby="offcanvasRightLabel"
    data-bs-backdrop="static"
  >
    <!-- Header -->
    <div class="offcanvas-header border-bottom">
      <div class="reprint-mode d-flex justify-content-end align-items-center">
        <h5 class="mb-0 me-2">
          {{ isEditMode ? "Edit Override" : "Create Override" }}
        </h5>
      </div>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
        (click)="resetForm()"
      ></button>
    </div>

    <!-- Body -->
    <div class="custom-modal-body modal-body">
      <form
        *ngIf="overrideForm"
        [formGroup]="overrideForm"
        class="modal-body-wraapper"
      >
        <!-- Description -->
        <div class="selector">
          <div class="custom-label">
            <label for="description" class="form-label required"
              >Description <span class="required">*</span></label
            >

            <p>:</p>
          </div>
          <input
            type="text"
            id="description"
            class="custom-form-select form-control goal-input"
            placeholder="Enter Description"
            maxlength="50"
            formControlName="description"
            [class.is-invalid]="
              overrideForm.get('description')?.invalid &&
              overrideForm.get('description')?.touched
            "
          />
        </div>

        <!-- Destination Store -->
        <div class="selector">
          <div class="custom-label">
            <label for="destinationStore" class="form-label required">
              Store <span class="required">*</span></label
            >
            <p>:</p>
          </div>
          <select
            id="destinationStore"
            class="custom-form-select form-select"
            formControlName="destinationStoreId"
            [class.is-invalid]="
              overrideForm.get('destinationStoreId')?.invalid &&
              overrideForm.get('destinationStoreId')?.touched
            "
          >
            <option [ngValue]="0" disabled>Select Store</option>
            <option
              *ngFor="let store of stores$ | async; trackBy: trackByStoreId"
              [ngValue]="store.storeId"
            >
              {{ store.storeName }}
            </option>
          </select>
        </div>

        <!-- Override Type -->
        <div class="selector">
          <div class="custom-label">
            <label class="form-label required"
              >Override Options <span class="required">*</span></label
            >
            <p>:</p>
          </div>
          <select
            class="custom-form-select form-select"
            formControlName="type"
            [class.is-invalid]="
              overrideForm.get('type')?.invalid &&
              overrideForm.get('type')?.touched
            "
            (change)="onOverrideTypeChange()"
          >
            <option [ngValue]="OverrideTypes.DateSpecific">By Date</option>
            <option
              *ngIf="showWeeklyOverrideOption"
              [ngValue]="OverrideTypes.WeeklySchedule"
            >
              By Week color
            </option>
          </select>
        </div>

        <!-- Week Color -->
        <div
          class="selector"
          *ngIf="overrideForm.get('type')?.value === OverrideTypes.DateSpecific"
        >
          <div class="custom-label">
            <label class="form-label required"
              >Date <span class="required">*</span></label
            >
            <p>:</p>
          </div>
          <div
            class="date-picker-box"
            [class.is-invalid]="
              overrideForm.get('weekColorDate')?.invalid &&
              overrideForm.get('weekColorDate')?.touched
            "
          >
            <span
              [style.backgroundColor]="selectedBgColor"
              (click)="openDatePicker(weekPicker)"
            >
              {{
                overrideForm.get("weekColorDate")?.value
                  ? (overrideForm.get("weekColor")?.value
                      ? overrideForm.get("weekColor")?.value + " / "
                      : "") +
                    (overrideForm.get("weekColorDate")?.value
                      | date: "MM-dd-yyyy")
                  : "Select date"
              }}
            </span>
            <img
              src="assets/dashboard/datepicker.svg"
              class="ms-2 svg-icon"
              alt="Calendar"
              (click)="openDatePicker(weekPicker)"
            />
            <input
              type="date"
              #weekPicker
              class="hidden-date-picker"
              formControlName="weekColorDate"
            />
          </div>
        </div>
        <!-- Weekly Schedule Week Color -->
        <div
          class="selector"
          *ngIf="
            showWeeklyOverrideOption &&
            overrideForm.get('type')?.value === OverrideTypes.WeeklySchedule
          "
        >
          <div class="custom-label">
            <label for="weekColor" class="form-label required"
              >Week Color <span class="required">*</span></label
            >
            <p>:</p>
          </div>
          <select
            id="weekColor"
            [style.backgroundColor]="selectedBgColor"
            class="custom-form-select form-select"
            [(ngModel)]="selectedWeekColorObj"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onWeekColorSelected($event)"
            [class.is-invalid]="
              overrideForm.get('weekColor')?.invalid &&
              overrideForm.get('weekColor')?.touched
            "
          >
            <option [ngValue]="null" disabled>Select Week Color</option>
            <option
              *ngFor="let week of weekColorSchedule"
              [ngValue]="week"
              [style.backgroundColor]="week.color"
            >
              {{ week.displayName }}
            </option>
          </select>
        </div>

        <!-- Set Override Reminder Toggle -->
        <div class="selector">
          <div class="custom-label">
            <label class="form-label">Set Reminder</label>
            <p>:</p>
          </div>

          <div class="reprint-mode override-toggle">
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="setReminder"
              />
            </div>

            <span class="toggle-text">
              {{ overrideForm.get("setReminder")?.value ? "Yes" : "No" }}
            </span>
          </div>
        </div>

        <!-- Reminder Date -->
        <div class="selector" *ngIf="overrideForm.get('setReminder')?.value">
          <div class="custom-label">
            <label class="form-label required">
              Reminder Date <span class="required">*</span>
            </label>
            <p>:</p>
          </div>

          <div
            class="date-picker-box"
            [class.is-invalid]="
              overrideForm.get('reminderDate')?.invalid &&
              overrideForm.get('reminderDate')?.touched
            "
          >
            <span (click)="openDatePicker(reminderPicker)">
              {{
                overrideForm.get("reminderDate")?.value
                  ? (overrideForm.get("reminderDate")?.value
                    | date: "MM-dd-yyyy")
                  : "Select a date"
              }}
            </span>

            <img
              src="assets/dashboard/datepicker.svg"
              class="ms-2 svg-icon"
              alt="Calendar"
              (click)="openDatePicker(reminderPicker)"
            />

            <input
              type="date"
              #reminderPicker
              class="hidden-date-picker"
              formControlName="reminderDate"
              [min]="minReminderDate"
            />
          </div>
        </div>

        <!-- Source Store (Optional) -->
        <div class="selector">
          <div class="custom-label">
            <label for="sourceStore" class="form-label">Source Store</label>
            <p>:</p>
          </div>
          <select
            id="sourceStore"
            class="custom-form-select form-select"
            formControlName="sourceStoreId"
            (change)="onSourceStoreChange(+$any($event.target).value)"
            [class.is-invalid]="
              overrideForm.get('sourceStoreId')?.invalid &&
              overrideForm.get('sourceStoreId')?.touched
            "
          >
            <option [ngValue]="0">Select Store</option>
            <option
              *ngFor="let store of stores$ | async; trackBy: trackByStoreId"
              [ngValue]="store.storeId"
            >
              {{ store.storeName }}
            </option>
          </select>
        </div>

        <div
          class="selector"
          *ngIf="overrideForm.get('sourceStoreId')?.value > 0 && !isEditMode"
        >
          <div class="custom-label">
            <label for="lpLocation" class="form-label"
              >Location
              <span class="required" *ngIf="!isEditMode">*</span></label
            >
            <p>:</p>
          </div>
          <select
            id="lpLocation"
            class="custom-form-select form-select"
            formControlName="warehouseLocationId"
            [class.is-invalid]="
              overrideForm.get('warehouseLocationId')?.invalid &&
              overrideForm.get('warehouseLocationId')?.touched
            "
          >
            <option [ngValue]="0" disabled>Select Location</option>
            <option
              *ngFor="let loc of filteredLocations$ | async"
              [ngValue]="loc.id"
            >
              {{ getWarehouseName(loc.warehouseId) + " - " + loc.name }}
            </option>
          </select>
          <small class="text-muted" *ngIf="isEditMode"
            >Optional when editing</small
          >
        </div>
        <!-- License Plate (Only in Edit Mode) -->
        <div class="selector" *ngIf="isEditMode">
          <div class="custom-label">
            <label for="licensePlate" class="form-label">License Plate</label>
            <p>:</p>
          </div>
          <select
            id="licensePlate"
            class="custom-form-select form-select"
            [(ngModel)]="selectedPlateId"
            (change)="onLicensePlateSelectionChange()"
            [ngModelOptions]="{ standalone: true }"
          >
            <option value="0" disabled>Select License Plate</option>
            <option value="new" class="lp-add-option">+ Add LP</option>
            <option
              value="empty"
              style="color: blue; font-weight: bold; justify-content: center"
            >
              Associate Empty
            </option>
            <option *ngFor="let lp of licensePlates" [value]="lp.id">
              {{ lp.referenceNumber }} | {{ lp.description }}
            </option>
          </select>
        </div>

        <!-- License Plate Form (when adding new) -->
        <ng-container *ngIf="associateEmptyLp && isEditMode">
          <div>
            <!-- LP Description -->
            <div class="selector">
              <div class="custom-label">
                <label for="lpDescription" class="form-label"
                  >Empty License Plates<span class="required">*</span></label
                >
                <p>:</p>
              </div>

              <select
                class="custom-form-select form-select"
                aria-label="Default select example"
                name="lp"
                [(ngModel)]="emptyLp"
                [ngModelOptions]="{ standalone: true }"
              >
                <option [ngValue]="null" hidden>Select License Plate</option>

                <option
                  *ngFor="let lp of emptyLicensePlates"
                  [ngValue]="lp"
                  style="justify-content: center"
                >
                  {{ lp.referenceNumber }} | {{ lp.description }}
                </option>
              </select>
            </div>

            <!-- Add LP Button -->
            <div class="d-flex justify-content-end">
              <button
                *ngIf="isAddingNewLP"
                type="button"
                class="btn modal-btn me-2 my-3"
                [disabled]="licensePlateForm.invalid"
                (click)="addNewLicensePlate()"
              >
                Add
              </button>
              <button
                *ngIf="associateEmptyLp"
                type="button"
                class="btn modal-btn me-2 my-3"
                (click)="updateLicensePlateStatusIfEmpty(emptyLp ?? null)"
              >
                Associate
              </button>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="isAddingNewLP && isEditMode && licensePlateForm">
          <div [formGroup]="licensePlateForm">
            <!-- LP Description -->
            <div class="selector">
              <div class="custom-label">
                <label for="lpDescription" class="form-label"
                  >LP Description <span class="required">*</span></label
                >
                <p>:</p>
              </div>
              <input
                type="text"
                id="lpDescription"
                class="custom-form-select form-control"
                placeholder="Enter LP Description"
                formControlName="description"
                [class.is-invalid]="
                  licensePlateForm.get('description')?.invalid &&
                  licensePlateForm.get('description')?.touched
                "
              />
            </div>

            <!-- LP Location -->
            <div class="selector">
              <div class="custom-label">
                <label for="lpLocation" class="form-label"
                  >LP Location <span class="required">*</span></label
                >
                <p>:</p>
              </div>
              <select
                id="lpLocation"
                class="custom-form-select form-select"
                formControlName="warehouseLocationId"
                [class.is-invalid]="
                  licensePlateForm.get('warehouseLocationId')?.invalid &&
                  licensePlateForm.get('warehouseLocationId')?.touched
                "
              >
                <option [ngValue]="0" disabled>Select Location</option>
                <option
                  *ngFor="let loc of filteredLocations$ | async"
                  [ngValue]="loc.id"
                >
                  {{ getWarehouseName(loc.warehouseId) + " - " + loc.name }}
                </option>
              </select>
            </div>

            <!-- Add LP Button -->
            <div class="d-flex justify-content-end">
              <button
                type="button"
                class="btn modal-btn me-2 my-3"
                [disabled]="licensePlateForm.invalid"
                (click)="addNewLicensePlate()"
              >
                Add
              </button>
            </div>
          </div>
        </ng-container>

        <!-- Action Buttons -->
        <div class="d-flex justify-content-end mt-4">
          <button
            type="button"
            class="btn modal-btn me-2 my-3"
            (click)="resetForm()"
            data-bs-dismiss="offcanvas"
          >
            Cancel
          </button>

          <button
            type="button"
            class="btn modal-btn add-btn my-3"
            [disabled]="!isFormValid"
            (click)="saveOverride()"
            data-bs-dismiss="offcanvas"
          >
            {{ isEditMode ? "Update" : "Add" }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Modal for Select Print Format -->
<div
  class="modal fade"
  id="labelFormatModal"
  tabindex="-1"
  aria-labelledby="labelFormatModalLabel"
  aria-hidden="true"
  data-bs-backdrop="static"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <!-- Header -->
      <div class="modal-header">
        <h5 class="modal-title" id="labelFormatModalLabel">
          Select Print Format
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
        ></button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <div class="mb-3">
          <label class="form-label"
            >Print Format <span class="required-star">*</span></label
          >

          <select class="form-select" [(ngModel)]="selectedLabelFormat">
            <option [ngValue]="null" disabled>Select print format</option>
            <option *ngFor="let format of labelFormats" [ngValue]="format">
              {{ format.name }}
            </option>
          </select>
        </div>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button
          #labelFormatModalCloseBtn
          type="button"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          Cancel
        </button>

        <button
          type="button"
          class="btn btn-primary"
          style="padding-inline: 25px"
          [disabled]="!selectedLabelFormat || isPrinting"
          (click)="confirmPrint()"
        >
          <span *ngIf="!isPrinting">Print</span>
          <span *ngIf="isPrinting">
            Printing
            <i class="fa fa-spinner fa-spin ms-2 print-spinner-icon"></i>
          </span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Popup Modal -->
<div class="custom-modal-backdrop" *ngIf="showDisablePopup">
  <div class="custom-modal">
    <div class="custom-modal-header">
      <h5>Disable Override</h5>
      <button class="close-btn" (click)="closePopup()">×</button>
    </div>
    <div class="custom-modal-body">
      <p *ngIf="!showWarning">
        Are you sure you want to disable this Override?
      </p>
      <p *ngIf="showWarning" class="warning">
        There are items available in license plates. Still want to disable?
      </p>
      <p class="warning" *ngIf="!showWarning">
        <strong>Once disabled, it cannot be undone.</strong>
      </p>
    </div>
    <div class="custom-modal-footer">
      <button class="btn cancel-btn" (click)="closePopup()">Cancel</button>
      <button
        class="btn disable-btn"
        *ngIf="!showWarning"
        (click)="disableFeature()"
      >
        Yes, Disable
      </button>
      <button
        class="btn disable-btn"
        *ngIf="showWarning"
        (click)="proceedWithDisable()"
      >
        Yes, Disable
      </button>
    </div>
  </div>
</div>
